import { lazy, memo } from 'react'
import { useSelector } from 'react-redux'
import { Box } from '@vp/swan'
import config from 'config'

import { getFormattedLocale } from 'shared/localeUtils'
import { getProductKey, getProductVersion } from 'client/store/config'
import { useAnalytics } from 'client/hooks/gallery/useAnalytics'
import { ANALYTICS_CATEGORY } from 'shared/constants'
import { getTenantId } from 'client/utils/getTenantId'
import { Locale, RequestorId } from './constants'
import { usePricingContext } from 'client/contexts/pricing/context'

const ShippingCalculator = lazy(() => import('@vp/shipping-calc-components'))

export type ShippingInfoPropTypes = {
  locale: i18n.Locale
  quantity: number
  selectedProductOptions: Gallery.ContentQuery.ProductOptions
}

export const ShippingInfo = memo(({ locale, quantity, selectedProductOptions }: ShippingInfoPropTypes) => {
  const analytics = useAnalytics()

  const productKey = useSelector(getProductKey)
  const productVersion = useSelector(getProductVersion)

  const pricingContext = usePricingContext()
  const retrievedPricingContext = pricingContext?.getPricingContext()

  const { locale: formattedLocale, region } = getFormattedLocale(locale)
  const vatInclusivity = retrievedPricingContext?.vatInclusive || false
  const tenantId = getTenantId(config.tenant, region)

  return (
    <Box className="shipping-info">
      <ShippingCalculator
        clientConfiguration={{
          requestor: config.appName,
          requestorId: RequestorId.Gallery6Client,
        }}
        productConfiguration={{
          productKey,
          productSelections: selectedProductOptions,
          productQuantity: quantity,

          productVersion: productVersion!,
        }}
        tenantConfiguration={{
          locale: formattedLocale as Locale,
          tenant: config.tenant,
          tenantId,
        }}
        trackingData={{
          ...analytics.getPageProperties(),
          category: ANALYTICS_CATEGORY.GALLERY,
        }}
        userConfiguration={{
          vatInclusivity,
        }}
      />
    </Box>
  )
})

ShippingInfo.displayName = 'ShippingInfo'
